import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { CmsModel } from 'client/data/models/cms';
import { getModelState } from 'client/data/luckdragon/model';
import { parseContent } from 'client/data/cms/content';
import { getArticleSchema } from 'client/seo/schemas/article';
import { getVideoSchemaData } from 'site-modules/brand-landing/pages/facebook-landing/seo';
import { FACEBOOK_LANDING_PATH } from 'site-modules/brand-landing/constants/facebook-landing';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { EdmundsNoGlobalNavNoAd } from 'site-modules/shared/pages/decorators/edmunds-no-global-nav-no-ad';
import { FACEBOOK_LANDING } from 'site-modules/shared/constants';
import { getMeta, getMetaRobots } from 'site-modules/shared/utils/seo-helper';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { PageModel } from 'client/data/models/page';
import { FacebookLanding, getHeroImage } from './facebook-landing';

export const pageOptions = {
  name: FACEBOOK_LANDING,
  category: 'brand_landing',
  adsCustomTargeting: {
    sect1: 'brandlanding',
  },
  preload: store => {
    const { mobile } = store.getState();
    const preloader = new ModelPreloader(store);

    preloader.resolve(`content["${FACEBOOK_LANDING_PATH}"]`, CmsModel);

    return preloader.load().then(modelState => {
      const content = modelState.get(`content["${FACEBOOK_LANDING_PATH}"]`, CmsModel);
      const parsedContent = parseContent(content);
      const preloadHeroImageAsset = {
        href: getStaticImageUrl(getHeroImage(parsedContent.child('hero-image'), mobile)),
        as: 'image',
      };
      const assetsToPreload = [];
      assetsToPreload.push(preloadHeroImageAsset);
      preloader.set('server.preloadedAssets', PageModel, assetsToPreload);
      return preloader.load();
    });
  },
  decorator: EdmundsNoGlobalNavNoAd,
  component: FacebookLanding,
  seo: state => {
    const modelState = getModelState(state);
    const content = parseContent(modelState.get(`content["${FACEBOOK_LANDING_PATH}"]`, CmsModel));
    const meta = getMeta(content);
    const robots = getMetaRobots(content);

    const videoEntry = content.child('video');
    const videoData = getVideoSchemaData(videoEntry);

    return {
      ...meta,
      ...robots,
      jsonld: [getArticleSchema({ articleObject: content }), videoData],
    };
  },
};

export default pageDefinition(pageOptions);
